import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { css } from "../../../styled-system/css";
import { HStack, VStack } from "../../../styled-system/jsx";
import Box from "../core/basic/Box";
import { useGetV4AdvReportByAd } from "../../modules/perf_reports/api/ads/v4AdvReportByAd";
import { AdvertisementCell } from "../../modules/advertising/tableCells/AdvertisementCell";
import { useTranslation } from "react-i18next";

const defaultRenderAd = (ad) => <AdvertisementCell ad={{ ...ad, id: ad.ad_id }} />;

export const AdToolPanel = ({
  adIds,
  emptyMessage,
  listMaxHeight = "260px",
  renderAd = defaultRenderAd,
  renderBeforeList,
  renderAfterList,
  renderActions,
}) => {
  const { t } = useTranslation(["chat"]);
  const resolvedEmptyMessage = emptyMessage ?? t(($) => $.chat["No Media Plans selected"]);
  const byAdOptionsGetter = useGetV4AdvReportByAd();
  const filters = useMemo(() => [{ id: "ad_id", value: { op: "anyof", value: adIds } }], [adIds]);
  const selectedAds = useQuery(
    byAdOptionsGetter({
      pagination: { pageIndex: 0, pageSize: 1000 },
      filters,
      sorting: [{ id: "ad_spend", desc: true }],
    }),
  );
  const ads = selectedAds?.data?.data ?? [];
  const context = {
    ads,
    isLoading: selectedAds.isLoading,
    isEmpty: ads.length === 0,
    query: selectedAds,
  };

  return (
    <Box empty={context.isEmpty} emptyMessage={resolvedEmptyMessage} isPending={context.isLoading}>
      <VStack gap={4} width="full" height="full" justifyContent="space-between">
        <VStack gap={2} width="full" justifyContent="start" maxHeight={listMaxHeight} overflowY="auto">
          {renderBeforeList?.(context)}
          {ads.map((ad) => (
            <div key={ad.ad_id} className={css({ width: "full" })}>
              {renderAd(ad, context)}
            </div>
          ))}
          {renderAfterList?.(context)}
        </VStack>
        {renderActions && (
          <HStack width="full" justifyContent="flex-end">
            {renderActions(context)}
          </HStack>
        )}
      </VStack>
    </Box>
  );
};
